var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Action, Selector, State, Store } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { finalize, tap } from 'rxjs/operators';
import { SharesApiService } from '../shares-api.service';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import uniqBy from 'lodash/uniqBy';
import { UpdateEntries } from '../../state/actions/commands';
var SetInitialUsers = /** @class */ (function () {
    function SetInitialUsers() {
    }
    SetInitialUsers.type = '[ShareDialog] Set Initial Users';
    return SetInitialUsers;
}());
export { SetInitialUsers };
var UpdateUserPermissions = /** @class */ (function () {
    function UpdateUserPermissions(user, permissions) {
        this.user = user;
        this.permissions = permissions;
    }
    UpdateUserPermissions.type = '[ShareDialog] Update User Permissions';
    return UpdateUserPermissions;
}());
export { UpdateUserPermissions };
var RemoveUser = /** @class */ (function () {
    function RemoveUser(user) {
        this.user = user;
    }
    RemoveUser.type = '[ShareDialog] Remove User';
    return RemoveUser;
}());
export { RemoveUser };
var SetUsers = /** @class */ (function () {
    function SetUsers(users) {
        this.users = users;
    }
    SetUsers.type = '[ShareDialog] Set Users';
    return SetUsers;
}());
export { SetUsers };
var SaveChanges = /** @class */ (function () {
    function SaveChanges() {
    }
    SaveChanges.type = '[ShareDialog] Save Changes';
    return SaveChanges;
}());
export { SaveChanges };
var ResetState = /** @class */ (function () {
    function ResetState() {
    }
    ResetState.type = '[ShareDialog] Reset';
    return ResetState;
}());
export { ResetState };
var ShareEntries = /** @class */ (function () {
    function ShareEntries(payload) {
        this.payload = payload;
    }
    ShareEntries.type = '[ShareDialog] Share Entries';
    return ShareEntries;
}());
export { ShareEntries };
var ShareEntriesFailed = /** @class */ (function () {
    function ShareEntriesFailed(messages) {
        this.messages = messages;
    }
    ShareEntriesFailed.type = '[ShareDialog] Share Entries Failed';
    return ShareEntriesFailed;
}());
export { ShareEntriesFailed };
var ShareDialogState = /** @class */ (function () {
    function ShareDialogState(store, sharesApi) {
        this.store = store;
        this.sharesApi = sharesApi;
    }
    ShareDialogState.usersWithAccess = function (state) {
        return state.usersWithAccess;
    };
    ShareDialogState.dirty = function (state) {
        return !isEqual(state.original, state.usersWithAccess);
    };
    ShareDialogState.loading = function (state) {
        return state.loading;
    };
    ShareDialogState.prototype.setInitialUsers = function (ctx) {
        var entries = this.store.selectSnapshot(DriveState.selectedEntries);
        var users = entries
            .map(function (entry) { return entry.users; })
            .reduce(function (all, curr) { return all.concat(curr); }, []);
        // make sure we don't override anything in main drive store
        users = cloneDeep(users);
        users = users.filter(function (user) { return !!user; });
        // multiple entries might contain same users
        var uniqueUsers = uniqBy(users, function (user) { return user.id; });
        // if permissions for same user are not same on
        // all selected entries, show "varies" permission
        if (entries.length > 1) {
            uniqueUsers.forEach(function (user) {
                var permissions = entries
                    .map(function (entry) { return entry.users.find(function (u) { return u.id === user.id; }); })
                    .filter(function (u) { return !!u; })
                    .map(function (u) { return Object.assign({}, u.entry_permissions); });
                if (entries.length !== permissions.length || permissions.some(function (p) { return !isEqual(p, permissions[0]); })) {
                    user.entry_permissions = { varies: true };
                }
            });
        }
        ctx.patchState({
            usersWithAccess: cloneDeep(uniqueUsers),
            original: uniqueUsers,
        });
    };
    ShareDialogState.prototype.setUsers = function (ctx, action) {
        ctx.patchState({
            usersWithAccess: action.users,
            original: cloneDeep(action.users)
        });
    };
    ShareDialogState.prototype.updateUserPermissions = function (ctx, action) {
        var users = ctx.getState().usersWithAccess;
        // update user permissions
        users.find(function (curr) { return curr.id === action.user.id; }).entry_permissions = action.permissions;
        ctx.patchState({ usersWithAccess: users });
    };
    ShareDialogState.prototype.removeUser = function (ctx, action) {
        var users = ctx.getState().usersWithAccess;
        // mark user as "removed"
        users.find(function (curr) { return curr.id === action.user.id; }).removed = true;
        ctx.patchState({ usersWithAccess: users });
    };
    ShareDialogState.prototype.resetState = function (ctx) {
        ctx.setState({
            loading: false,
            usersWithAccess: [],
            original: [],
        });
    };
    ShareDialogState.prototype.saveChanges = function (ctx) {
        var _this = this;
        ctx.patchState({ loading: true });
        var state = ctx.getState();
        var entries = this.store.selectSnapshot(DriveState.selectedEntries);
        var users = state.usersWithAccess
            // filter out entry owner
            .filter(function (user) { return !user.owns_entry; })
            // filter out users if they do not have same permissions for
            // all selected entries (except for users that are being removed)
            .filter(function (user) { return !user.entry_permissions.varies || user.removed; })
            .map(function (user) {
            return { id: user.id, removed: user.removed, permissions: user.entry_permissions };
        });
        return this.sharesApi.updateUsers({ entries: entries.map(function (e) { return e.id; }), users: users }).pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function (response) {
            var newUsers = response.users;
            // update permissions in share dialog store
            ctx.patchState({
                usersWithAccess: newUsers,
                original: cloneDeep(newUsers),
            });
            _this.updateEntriesInDriveStore(newUsers);
        }));
    };
    ShareDialogState.prototype.shareEntries = function (ctx, action) {
        var _this = this;
        ctx.patchState({ loading: true });
        var payload = __assign({}, action.payload, { entries: this.store.selectSnapshot(DriveState.selectedEntries) });
        return this.sharesApi.shareEntries(payload)
            .pipe(finalize(function () { return ctx.patchState({ loading: false }); }), tap(function (response) {
            ctx.dispatch(new SetUsers(response.users));
            _this.updateEntriesInDriveStore(response.users);
        }, function (errorResponse) {
            ctx.dispatch(new ShareEntriesFailed(errorResponse.messages));
        }));
    };
    ShareDialogState.prototype.updateEntriesInDriveStore = function (newUsers) {
        var entries = this.store.selectSnapshot(DriveState.selectedEntries);
        // update permissions in main drive store, otherwise we'll get old
        // permissions if user re-opens share dialog without page reload
        var updatedEntries = entries.map(function (entry) {
            entry.users = newUsers;
            return entry;
        });
        this.store.dispatch(new UpdateEntries(updatedEntries));
    };
    __decorate([
        Action(SetInitialUsers),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState.prototype, "setInitialUsers", null);
    __decorate([
        Action(SetUsers),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetUsers]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState.prototype, "setUsers", null);
    __decorate([
        Action(UpdateUserPermissions),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateUserPermissions]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState.prototype, "updateUserPermissions", null);
    __decorate([
        Action(RemoveUser),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateUserPermissions]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState.prototype, "removeUser", null);
    __decorate([
        Action(ResetState),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState.prototype, "resetState", null);
    __decorate([
        Action(SaveChanges, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState.prototype, "saveChanges", null);
    __decorate([
        Action(ShareEntries, { cancelUncompleted: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ShareEntries]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState.prototype, "shareEntries", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState, "usersWithAccess", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState, "dirty", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ShareDialogState, "loading", null);
    ShareDialogState = __decorate([
        State({
            name: 'shareDialog',
            defaults: {
                usersWithAccess: [],
                original: [],
                loading: false,
            }
        }),
        __metadata("design:paramtypes", [Store,
            SharesApiService])
    ], ShareDialogState);
    return ShareDialogState;
}());
export { ShareDialogState };
